type IconProps = {
  checked: boolean
}
const CheckboxIcon = ({ checked }: IconProps) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    {checked ? (
      <>
        <rect
          x="0.245117"
          y="0.201172"
          width="12"
          height="12"
          rx="2"
          fill="#23B0FF"
        />
        <path
          d="M9.91699 3.70117L4.76074 8.85742L2.41699 6.51367"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ) : (
      <rect
        x="0.745117"
        y="0.578125"
        width="11.2461"
        height="11.2461"
        rx="1.5"
        fill="#F6F6F6"
        stroke="#828282"
      />
    )}
  </svg>
)

export default CheckboxIcon
